import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import Accommodations from '../../features/accommodations/Accommodations';
import AccommodationDetailsView from '../../features/accommodations/AccommodationDetails';
import AddAccommodation from '../../features/accommodations/AddAccommodation';
import AccommodationGroups from '../../features/accommodations/AccommodationGroups';
import AccommodationGroupDetails from '../../features/accommodations/AccommodationGroupDetails';
import Tags from '../../features/tags/Tags';
import AccommodationAttributes from '../../features/accommodations/AccommodationAttributes';
import AccommodationAttributeDetails from '../../features/accommodations/AccommodationAttributeDetails';
import AddOns from '../../features/addons/AddOns';
import AddOnDefinitionDetails from '../../features/addons/AddOnDefinitionDetails';
import NotFound from '../../common/components/router/NotFound';
import TagDetails from '../../features/tags/TagDetails';
import SettlementReport from '../../features/statistics/SettlementReport';
import OwnerReport from '../../features/statistics/OwnerReport';
import AddNew from '../../features/addons/AddNew';

const AccommodationAppRoutes = () => (
  <Routes>
    <Route
      path="/search"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <Accommodations />
        </PrivateRoute>
      }
    />
    <Route
      path="/details/:accommodationId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <AccommodationDetailsView />
        </PrivateRoute>
      }
    />
    <Route
      path="/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationModify]}>
          <AddAccommodation />
        </PrivateRoute>
      }
    />
    <Route
      path="/accommodationgroups"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <AccommodationGroups />
        </PrivateRoute>
      }
    />
    <Route
      path="/accommodationgroups/:accommodationgroupId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <AccommodationGroupDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/tags"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <Tags />
        </PrivateRoute>
      }
    />
    <Route
      path="/tags/:tagId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <TagDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/accommodationattributes"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <AccommodationAttributes />
        </PrivateRoute>
      }
    />
    <Route
      path="/accommodationattributes/:accommodationattributeId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <AccommodationAttributeDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/addondefinitions"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <AddOns />
        </PrivateRoute>
      }
    />
    <Route
      path="/addondefinitions/addnew"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <AddNew />
        </PrivateRoute>
      }
    />
    <Route
      path="/addondefinitions/:addonId"
      element={
        <PrivateRoute
          permissions={[
            PERMISSIONS.AccommodationRead,
            PERMISSIONS.AccommodationModify,
          ]}
        >
          <AddOnDefinitionDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/settlementreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <SettlementReport />
        </PrivateRoute>
      }
    />
    <Route
      path="/ownerreport"
      element={
        <PrivateRoute permissions={[PERMISSIONS.AccommodationRead]}>
          <OwnerReport />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AccommodationAppRoutes;
